import { useSelector } from "react-redux";
// @ts-expect-error: ignoring as it is existing js file
import { userSelector } from "@/store/slices/userSlice";
import type { UserSlice, UserState } from "@/store/slices/types/userSlice";

const useTemplateServices = () => {
  const {
    is_disclosure_template: isDisclosureTemplate,
    is_consumer_privacy_doc_template: isConsumerPrivacyDocTemplate,
    is_commercial_privacy_doc_template: isCommercialPrivacyDocTemplate,
    is_lender_product_quotes_doc_template: isLenderProductQuotesDocTemplate,
  } = useSelector<UserSlice, UserState>(userSelector);

  const canUseDisclosureServices = isDisclosureTemplate;
  const canUseConsumerPrivacyDocTemplate = isConsumerPrivacyDocTemplate;
  const canUseCommercialPrivacyDocTemplate = isCommercialPrivacyDocTemplate;
  const canUseLenderProductQuotesDocTemplate = isLenderProductQuotesDocTemplate;

  return {
    canUseDisclosureServices,
    canUseConsumerPrivacyDocTemplate,
    canUseCommercialPrivacyDocTemplate,
    canUseLenderProductQuotesDocTemplate
  };
};

export { useTemplateServices };
